// latest: zhangmyh 2017-10-16 2:42 PM
import { Collection } from 'common'
import 'model/certification'
Collection.define('certification.list', {
  model: 'certification.model',
  proxy: {
    get: '/cpu-supplymgr/certificationIndicator/pageQuery'
  }
})

export default Collection.create('certification.list')



// WEBPACK FOOTER //
// ./src/data/collection/certification/index.js